import { getImpersonatedEmail, stopImpersonating } from '@/components/admin/impersonation';

export default function ImpersonationBanner() {
    const email = getImpersonatedEmail();
    if (!email) return null;

    const stop = () => {
        stopImpersonating();
        window.location.assign('/admin');
    };

    return (
        <div role="status" className="sticky top-0 z-[9999] flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-semibold text-black">
            <span>Viewing the site as {email}</span>
            <button type="button" onClick={stop} className="rounded-full bg-black px-4 py-1 text-white hover:bg-grey10">
                Stop impersonating
            </button>
        </div>
    );
}
